import { getStringWidth } from '@visx/text';

// Chart
export const CHART_HEIGHT = 240;

export const TICK_FONT_SIZE = 10;

// X Axis
export const X_AXIS_OFFSET_LEFT = 40;
export const X_AXIS_OFFSET_RIGHT = 60;
export const X_AXIS_PADDING_LEFT = 20;
export const X_AXIS_PADDING_RIGHT = 20;

// Y Axis
export const Y_AXIS_OFFSET_RIGHT = 40;
export const Y_AXIS_OFFSET_TOP = 30;
export const Y_AXIS_OFFSET_BOTTOM = 16.5; // Axis + Axis tickers height

// Line Path
export const LINE_PATH_STROKE = 4;

export const X_AXIS_TICK_PADDING_X = 8;
export const X_AXIS_TICK_LABEL_WIDTH =
  (getStringWidth('2999', {
    fontSize: TICK_FONT_SIZE,
  }) ?? 25) + X_AXIS_TICK_PADDING_X;

type CalculateFutureRevenueAndEarningsProps = {
  timePeriod: number; // Future year projection
  reportingUnit: number | null;
  revenue: number | null; // Present day revenue in reporting units
  revenuePercentage: number; // Revenue growth percetange p.a.
  profitMarginPercentage: number;
};

export const calculateFutureRevenueAndEarnings = ({
  timePeriod,
  reportingUnit,
  revenue,
  revenuePercentage,
  profitMarginPercentage,
}: CalculateFutureRevenueAndEarningsProps) => {
  const presentRevenue =
    revenue !== null && reportingUnit !== null ? revenue * reportingUnit : 0;
  const revenueRate = 1 + revenuePercentage / 100;
  const futureRevenue = presentRevenue * revenueRate ** timePeriod;
  const futureNetIncome = (profitMarginPercentage / 100) * futureRevenue;

  return {
    futureRevenue,
    futureNetIncome,
  };
};
